<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal='false' width='800px'>
    <el-form label-position="right" label-width="80px">
      <el-form-item label="电台">
        <el-input v-model="form.name" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="频率">
        <el-slider v-model="form.frequency" show-input :min="87" :max="108" :step='0.1'> </el-slider>
      </el-form-item>
      <el-form-item label="地区">
        <el-select v-model="form.area" filterable placeholder="请选择">
          <el-option v-for="(item,i) in areas" :key="i" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间段">
        <week-time :weekTimes='form.runtime' @change='weekTimeChange'></week-time>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import WeekTime from "vue-week-time";
  export default {
    props: ["data"],
    watch: {
      data(val) {
        this.form = JSON.parse(JSON.stringify(val));
      }
    },
    components: {
      "week-time": WeekTime
    },
    methods: {
      weekTimeChange(weekTime, weekTimeStr) {
        this.form.runtime = weekTime;
      },
      save() {
        this.visible = false;
        if (this.form.id) {
          this.$emit("save", JSON.parse(JSON.stringify(this.form)));
          this.$getJSON("/radio/u_whitelst", this.form).then(res => {
            this.$message({
              type: "success",
              message: "保存成功"
            });
          });
        } else {
          this.$getJSON("/radio/i_whitelst", this.form).then(res => {
            this.$emit("save", JSON.parse(JSON.stringify(this.form)), res.data[0].new_id);
            this.$message({
              type: "success",
              message: "保存成功"
            });
          });
        }
      },
      show() {
        this.visible = true;
      },
      addTime(day) {
        day.timespan.push({
          value: [new Date(), new Date()]
        });
      },
      addDay() {
        this.form.runtime.push({
          weekday: "周一",
          timespan: [{
            value: [new Date(), new Date()]
          }]
        });
      }
    },
    data() {
      return {
        title: "修改白名单",
        areas: [
          "全市",
          "闵行",
          "嘉定",
          "浦东",
          "松江",
          "奉贤",
          "宝山",
          "金山",
          "青浦",
          "崇明"
        ],
        visible: false,
        form: {}
      };
    }
  };

</script>
<style scoped>
  .week-time table {
    height: 400px;
  }

</style>



// WEBPACK FOOTER //
// src/components/WhiteList/Edit.vue